import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";

const columns = [
  {
    title: "SERVICES",
    items: ["Logistics Solution", "E-Commerce Logistics", "Warehousing Soltuons", "Government Project Deliveries"],
  },  
  {
    title: "Quick Links",
    items: ["Home", "About Us", "Track Now", "Contact Us"],
  },
];

export default function Footer() {
  return (
    <footer className="rx-footer">
      <div className="rx-footer-grid">
        <div>
          
          <div className="rx-footer-about">
            <img src="./img/logo.png" alt="" class="footer-logo"/>
            <p>Reliable Express delivers smart, dependable, and efficient logistics solutions for businesses of every size.</p>
          </div>
        </div>
        {columns.map((c) => (
          <div key={c.title}>
            <div className="rx-footer-col-title">{c.title}</div>
            {c.items.map((it) => (
              <div className="rx-footer-col-item" key={it}>
                {it}
              </div>
            ))}
          </div>
        ))}
        <div>
          
          <div className="rx-footer-about">
            <div className="rx-footer-row">
              <MapPin size={16} />
              <span>
                # 320, Neta Ji Park, Balloke Road,
Badi Haibowal, Ludhiana-141001, Punjab.
              </span>
            </div>
            <div className="rx-footer-row">
              <Phone size={16} />
              <a href="tel:+919888004386">
  <span>+91 9888004386</span>
</a>
            </div>
            <div className="rx-footer-row">
              <Mail size={16} />
              <a href="mailto:reliable.express@outlook.com"><span>reliable.express@outlook.com</span></a>
            </div>
          </div>
        </div>
      </div>
      <div className="rx-footer-bottom">
        <span>© 2026 Reliable Express. All Rights Reserved.</span>
        <span className="rx-footer-bottom-links">
          <span>Powered by: SIPL</span>
        </span>
      </div>
    </footer>
  );
}
